import { forAllCallback } from "../../../scripts/utils/helpers";

export default () => {
    forAllCallback(".read-more-less", (el) => {
        const mediaQuery = window.matchMedia("(max-width: 768px)");

        if (mediaQuery.matches) {
            // only set these properties on mobile devices
            el.previousElementSibling.style = "display: inline";
            const readLess = el.querySelector(".read-less");
            const readMore = el.querySelector(".read-more");
            readMore.firstElementChild.style = "display:inline";

            const toggleButton = el.parentElement.querySelector(
                ".read-more-less--button"
            );
            function textVisible() {
                if (readMore.classList.contains("hide")) return false;
                return true;
            }
            toggleButton.addEventListener("click", () => {
                readLess.classList.toggle("hide");
                readMore.classList.toggle("hide");
                if (textVisible()) {
                    toggleButton.innerText = "show less";
                } else {
                    toggleButton.innerText = "show more";
                }
            });
        }
    });
};
